// Form model of "Přidat zásilku" and its mapping to the request body.

export const EMPTY_FORM = {
  direction: 'prichozi', status: 'objednano', carrierCode: '', trackingNumber: '', orderRef: '', description: '',
  senderName: '', recipientName: '', expectedDelivery: '', customerId: '', supplierId: '', machineId: '', orderBatchId: '', note: '',
};

// Body for POST / (and for "create" in POST /review/:emailId/link): only filled fields, ids as numbers
export function buildCreateBody(form) {
  const body = { direction: form.direction, status: form.status };
  ['carrierCode', 'trackingNumber', 'orderRef', 'description', 'senderName', 'recipientName', 'expectedDelivery', 'note'].forEach((k) => {
    const v = String(form[k] ?? '').trim();
    if (v) body[k] = v;
  });
  ['customerId', 'supplierId', 'machineId', 'orderBatchId'].forEach((k) => {
    if (form[k]) body[k] = Number(form[k]);
  });
  return body;
}
